<template>
  <v-app-bar :elevation="1">
    <v-app-bar-title>{{ $soul.title }}</v-app-bar-title>
    <v-spacer></v-spacer>
    <template v-if="isLoggedIn">
      <v-menu transition="scale-transition">
        <template #activator="{ props }">
          <v-btn v-bind="props" icon size="large">
            <v-avatar size="30" v-if="avatarUrl && !avatarFailed">
              <v-img :src="avatarUrl" :alt="userInfo.nickname" @error="avatarFailed = true" />
            </v-avatar>
            <iconify-icon v-else width="30" icon="mdi:account-circle"></iconify-icon>
          </v-btn>
        </template>
        <v-list density="compact" min-width="220">
          <v-list-item
            prepend-icon="mdi-account"
            :title="userInfo.nickname || '个人中心'"
            @click="goTo({ name: 'user' })"
          />
          <v-list-item
            prepend-icon="mdi-cellphone-arrow-down"
            :title="`强制刷新 v${appVersion || ''}`"
            :disabled="forceUpdating"
            @click="forceRefresh"
          />
          <v-list-item
            prepend-icon="$logout"
            :title="$t('login.logout')"
            @click="loggingout"
          />
        </v-list>
      </v-menu>
    </template>
    <template v-else>
      <v-btn icon @click="setShowLogin(true)">
        <iconify-icon width="22" icon="solar:login-line-duotone"></iconify-icon>
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import { useRootStore } from '@/stores/root'
import { useVisitorStore } from '@/stores/visitor'
import { forceAppUpdate } from '@/utils/updater.js'
import { mapActions, mapState } from 'pinia'

export default {
  components: {},
  props: {},
  data() {
    return {
      forceUpdating: false,
      avatarFailed: false
    }
  },
  computed: {
    ...mapState(useRootStore, ['showLogin', 'appVersion']),
    ...mapState(useVisitorStore, ['userInfo', 'isLoggedIn']),
    avatarUrl() {
      return this.userInfo?.avatar || this.userInfo?.profile?.avatar || ''
    }
  },
  watch: {
    avatarUrl() {
      this.avatarFailed = false
    }
  },
  methods: {
    ...mapActions(useRootStore, ['setShowLogin']),
    ...mapActions(useVisitorStore, ['logout']),
    loggingout() {
      this.$confirm(
        this.$t('common.confirm_to', [this.$t('login.logout')]),
      ).then((r) => {
        if (r) {
          this.logout()
        }
      })
    },
    forceRefresh() {
      if (this.forceUpdating) return
      this.$confirm('将清除本地缓存并重新加载，未保存操作可能丢失。确定强制刷新？').then((r) => {
        if (r !== true) return
        this.forceUpdating = true
        forceAppUpdate().catch((e) => {
          this.forceUpdating = false
          console.warn('[updater] force refresh failed', e)
          this.$alert('强制刷新失败，请稍后重试或清除网站数据')
        })
      })
    },
    goTo(to) {
      this.$router.push(to)
    }
  }
}
</script>

<style scoped lang="sass"></style>
